module.exports = __webpack_public_path__ + "static/media/choose-account.2c8fd2b7.png";